<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
  

    <div>
      <label>שם משפחה/חברה:</label>
      <input type="text" formControlName="lastName">
    </div>
    
    <div>
      <label>שם פרטי:</label>
      <input type="text" formControlName="firstName">
      <small class="text-danger" *ngIf="(f.firstName.touched || submitted) && f.firstName.errors?.required">
        שם פרטי נדרש.
      </small>
    </div>
    
    <div>
      <label>טלפון נייד:</label>
      <input type="text" formControlName="mobilePhone">
      <small class="text-danger" *ngIf="(f.mobilePhone.touched || submitted) && f.mobilePhone.errors?.required">
        מספר טלפון נייד נדרש.
      </small>
      <small class="text-danger" *ngIf="(f.mobilePhone.touched || submitted) && f.mobilePhone.errors?.pattern">
        פורמט מספר טלפון לא תקין.
      </small>
    </div>

    <div>
      <label>ת.ז. / ח.פ:</label>
      <input type="text" formControlName="personalId">
    </div>
    
    
    <div>
      <label>עיר:</label>
      <input type="text" formControlName="city">
    </div>
    
    <div>
      <label>רחוב:</label>
      <input type="text" formControlName="street">
    </div>
    
    <div>
      <label>מס' בניין:</label>
      <input type="text" formControlName="buildingNumber">
    </div>
    
    <div>
      <label>מייל:</label>
      <input type="email" formControlName="email">
      <small class="text-danger" *ngIf="(f.email.touched || submitted) && f.email.errors?.required">
        דוא"ל נדרש.
      </small>
      <small class="text-danger" *ngIf="(f.email.touched || submitted) && f.email.errors?.email">
        כתובת דוא"ל לא תקינה.
      </small>
    </div>
    
    <!-- <button type="submit" class="btn btn-primary">Submit</button> -->
  </form>
  